import { useContext, useMemo } from 'react';

// @ts-ignore - no types for ar-feature-gating
import { splitClient } from '@nextroll/ar-feature-gating';
import i18n from '@nextroll/ar-i18n';
import {
    BUSINESS_UNIT_ADROLL,
    BUSINESS_UNIT_ROLLWORKS,
    Logo, // @ts-ignore - no types for ar-style-base
} from '@nextroll/ar-style-base';

import ThemeWrapperContext from '../contexts/ThemeWrapperContext';

const AbmTransitionBannerContent = ({ source }: { source: string }) => {
    /**
     * banner messages are different based on where / which page it lives in
     */
    const title = useMemo(() => {
        switch (source) {
            case 'PasswordResetInitPage':
            case 'PasswordResetSavePage':
            case 'SignInPage':
                return i18n.gettext('RollWorks is now AdRoll ABM.');
            case 'SignUpPage':
                return i18n.gettext('Meet AdRoll ABM (formerly RollWorks).');
            default:
                return null;
        }
    }, [source]);
    const subtitle = useMemo(() => {
        switch (source) {
            case 'PasswordResetInitPage':
            case 'PasswordResetSavePage':
            case 'SignUpPage':
                return i18n.gettext(
                    'Same trusted tool, refreshed name and look.'
                );
            case 'SignInPage':
                return i18n.gettext(
                    'Use your existing login details to access your account.'
                );
            default:
                return null;
        }
    }, [source]);

    /**
     * leading icons a.k.a. RollWorks -> Adroll
     */
    const logos = useMemo(
        () => (
            <div className='eh-abm-transition-banner-logos'>
                <Logo
                    i18n={i18n}
                    businessUnit={BUSINESS_UNIT_ROLLWORKS}
                    wordmark={false}
                    height='16px'
                    disableRollWorksTheme={false}
                />
                {'\u2192'}
                <Logo
                    i18n={i18n}
                    businessUnit={BUSINESS_UNIT_ADROLL}
                    wordmark={false}
                    height='16px'
                />
            </div>
        ),
        []
    );

    /**
     * "learn more" link
     */
    const link = useMemo(
        () => (
            <a
                href='https://www.adroll.com/blog/introducing-adrollabm'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='learn more about AdRoll ABM'
            >
                {i18n.gettext('Learn More')}
            </a>
        ),
        []
    );

    return (
        <div className='eh-abm-transition-banner'>
            {logos}
            <strong>{title}</strong>
            <span>{subtitle}</span>
            {link}
        </div>
    );
};

const AbmTransitionBanner = ({ source }: { source: string }) => {
    const { businessUnit } = useContext(ThemeWrapperContext);

    if (businessUnit === BUSINESS_UNIT_ADROLL) {
        return null; // do NOT show banners on AdRoll pages
    }
    return <AbmTransitionBannerContent source={source} />;
};

export default AbmTransitionBanner;
